<template>
  <div class="text-center">
    <b-badge pill :variant="signatureTypeColor">
      {{signatureTypeText}}
    </b-badge>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    signatureTypeText () {
      if (this.value === 'digital') {
        return 'Digital'
      } else if (this.value === 'electronic_without_otp') {
        return 'Electrónica Simple'
      } else if (this.value === 'electronic') {
        return 'Electrónica Avanzada'
      }
    },
    signatureTypeColor () {
      if (this.value === 'digital') {
        return 'primary'
      } else if (this.value === 'electronic_without_otp') {
        return 'secondary'
      } else if (this.value === 'electronic') {
        return 'warning'
      }
    }
  }
}
</script>
